import { useEffect, useRef } from 'react'

import { useSelector } from 'react-redux'
import { routerSlice, type AppsRoutes } from '@wellesley/router'
// eslint-disable-next-line no-restricted-imports -- we can use at host level
import { useNavigate } from 'react-router-dom'
import { useCurrentFullPath } from '../../../host/hooks/useCurrentFullPath'

export const useRemoteNavigateToPath = () => {
  const navigate = useNavigate()
  const lastPathRef = useRef('')
  const currentFullPath = useCurrentFullPath()

  const path = useSelector(routerSlice.selectors.selectPath)
  useEffect(() => {
    if (path && path !== lastPathRef.current) {
      lastPathRef.current = path

      if (currentFullPath !== path) {
        navigate(path as AppsRoutes, { replace: true })
      }
    }
  }, [path, navigate, currentFullPath])
}
